"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkplaceRoleRoutes = void 0;
var WorkplaceRoleRoutes;
(function (WorkplaceRoleRoutes) {
    WorkplaceRoleRoutes["BasePrefix"] = "workplaces/roles";
    WorkplaceRoleRoutes["ById"] = ":workplaceRoleId";
    WorkplaceRoleRoutes["All"] = "all/:workplaceId";
})(WorkplaceRoleRoutes = exports.WorkplaceRoleRoutes || (exports.WorkplaceRoleRoutes = {}));
